import {
  Box, Button, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { Props } from './type';
import useStyles from './styles';

export default function DialogConfirmLogout({ handleConfirmLogout, isOpen = false, data = '' }:Props) {
  const classes = useStyles();
  const handleActionConfirm = () => {
    handleConfirmLogout?.();
  };

  useEffect(() => {
    /**
       * Check authority
       */
  }, []);

  return (
    <Box>
      <Dialog
        open={isOpen}
        disableEscapeKeyDown={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" classes={{ root: classes.cssDialogTitle }}>Win-Board</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            一定時間操作がなかったため自動的にログアウトしました。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleActionConfirm}
            color="primary"
            autoFocus={true}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
